if (!customElements.get('load-more')) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setProperties();

      window.addEventListener('shopify:section:load', () => {
        this.setProperties();
      });

      this.btnLoadMore.addEventListener('click', (e) => {
        e.preventDefault();

        this.btnLoadMore.setAttribute('disabled', true);

        this.loadMoreResources();
      });
    }

    setProperties() {
      this.section = this.closest('[data-section]');
      this.resourcesGrid = this.section.querySelector('[data-resources-grid]');
      this.btnLoadMore = this.querySelector('[data-button-load-more]');
      this.isLastPage = this.classList.contains('hidden');
    }

    async loadMoreResources() {
      try {
        const nextPageResponse = await fetch(
          `${this.btnLoadMore.dataset.href}`,
        );
        const nextPageText = await nextPageResponse.text();

        const nextPageHTML = new DOMParser().parseFromString(
          nextPageText,
          'text/html',
        );

        const resourcesGrid = nextPageHTML.querySelector(
          '[data-resources-grid]',
        );
        const loadMoreContainer = nextPageHTML.querySelector('load-more');
        const btnLoadMore = loadMoreContainer.querySelector(
          '[data-button-load-more]',
        );

        const isLoadMoreHidden = loadMoreContainer.classList.contains('hidden');

        this.resourcesGrid.insertAdjacentHTML(
          'beforeend',
          resourcesGrid.innerHTML,
        );

        if (isLoadMoreHidden) {
          this.isLastPage = true;
          this.classList.add('hidden');

          return;
        }

        this.btnLoadMore.dataset.href = btnLoadMore.dataset.href;
      } catch (error) {
        console.error(error);

        alert(error.message);
      } finally {
        this.btnLoadMore.removeAttribute('disabled');
      }
    }
  }

  customElements.define('load-more', LoadMore);
}
